import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import BuyerOnlyRouteMixin from 'sh-www/mixins/buyer-only-route-mixin';
import { ASSIGNMENT } from 'sh-www/models/assignment';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';

class ProjectCreateRoute extends Route.extend(BuyerOnlyRouteMixin) {
  @service('states/routes/posting-create') state;
  @service('state-managers/routes/posting-create') stateManager;
  @service session;

  model() {
    this.stateManager.initStateManager();
    this.stateManager.setPostingType(ASSIGNMENT.TYPES.STANDARD);
    this.stateManager.setCreatedFrom(ASSIGNMENT.CREATED_FROM.DIRECT);
    this.stateManager.updateForDirectHire(0);
  }

  setupController(controller) {
    super.setupController(...arguments);

    controller.initializeSearch.perform();
  }

  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.searchResultsUpdates.cancelAll({ resetState: true });
      controller.handleNewSearch.cancelAll({ resetState: true });
      controller.showCompanyHiredFreelancerSearchPage.cancelAll({ resetState: true });

      // only reset text since task in setupController will reset others
      controller.set('searchText', '');

      // close overlay if they click hire
      this.controllerFor('application').set('profileOverlay', null);
    }
  }

  activate(transition) {
    super.activate(...arguments);
    trackPageViewFromTransition(this, transition, '/project/create/find-freelancer/');
  }
}

export default ProjectCreateRoute;
